<div class="work-shift__cell-container" [class.work-shift__cell-container--ca]="isGRS">
  <ng-template #cellPopContent>
    <app-loader *ngIf="cellLoading"></app-loader>
    <app-field>
      <label>
        <span class="title title--s title--required">Вид затрат времени</span>
      </label>
      <app-select
        #workTypeSelect
        [key]="selectKey"
        [items]="workTypesData"
        (callback)="onChangeTemplateWorkType($event)"
        [textKey]="'ct_name'"
        [defaultText]="'Выберите значение'"
        [initBy]="workTypeSelected"
        [isDisabled]="isFuncDisabled || isBlockedEditCreate"
        [name]="'ctName'"
      ></app-select>
    </app-field>
    <div class="mt-16" *ngIf="workTypeSelected && workTypeSelected.ct_id === 1">
      <app-field>
        <label>
          <span class="title title--s">Время смены</span>
        </label>
        <content-block>
          <div class="grid grid--va-middle grid--gap-8">
            <div class="grid__box grid__box--size-min">с</div>
            <div class="grid__box">
              <app-time-picker
                [(ngModel)]="startWorkTime"
                (ngModelChange)="onChangeStartTemplatePeriodTime($event)"
                [disabled]="isFuncDisabled || isBlockedEditCreate"
              ></app-time-picker>
            </div>
            <div class="grid__box grid__box--size-min">до</div>
            <div class="grid__box">
              <app-time-picker
                [(ngModel)]="endWorkTime"
                (ngModelChange)="onChangeEndTemplatePeriodTime($event)"
                [disabled]="isFuncDisabled || isBlockedEditCreate"
              ></app-time-picker>
            </div>
          </div>
        </content-block>
      </app-field>
    </div>
    <div class="mt-16" *ngIf="workTypeSelected && workTypeSelected.ct_id === 2">
      <app-field>
        <label>
          <span class="title title--s title--required">Временное место работы</span>
        </label>
        <app-combobox
          [items]="workPlacesList"
          (callback)="onChangeTemplateWorkPlace($event)"
          [textKey]="'sector_number_str'"
          [defaultText]="'Выберите значение'"
          [initBy]="workPlaceSelected"
          [isDisabled]="isFuncDisabled || isBlockedEditCreate"
          [name]="'workPlaceCell'"
        ></app-combobox>
      </app-field>
    </div>
    <div class="mt-16" [hidden]="isShowComment">
      <span class="ctrl link link--dotted-gray-dark" (click)="onShowComment()">Добавить комментарий</span>
    </div>
    <div class="mt-16" [hidden]="!isShowComment">
      <app-field>
        <label>
          <span class="title title--s">Комментарий</span>
        </label>
        <textarea
          class="input-textarea"
          rows="3"
          id="{{ 'comment' + cell.workday + '-' + user.u_id }}"
          [(ngModel)]="comment"
          [disabled]="isFuncDisabled || isBlockedEditCreate"
        ></textarea>
      </app-field>
    </div>
    <div class="mt-16" *ngIf="cellError || isBlockedEditCreate">
      <app-message [type]="'error'">
        <div message-content>{{ cellError }}</div>
      </app-message>
    </div>
    <div class="grid grid--va-middle mt-24">
      <div class="grid__box grid__box--size-min">
        <button
          class="button"
          type="button"
          id="{{ 'appSaveCellSchedule' + cell.workday + '-' + user.u_id }}"
          [disabled]="isFuncDisabled || timeValidationDisabled || isBlockedEditCreate"
          (click)="onSaveCellData(false)"
        >
          Сохранить
        </button>
      </div>
      <div class="grid__box grid__box--size-min">
        <button class="ctrl link link--dotted-gray-dark" type="button" id="{{ 'appCancelCellSchedule' + cell.workday + '-' + user.u_id }}" (click)="onCloseCell()">Отмена</button>
      </div>
      <div class="grid__box grid__box--size-min grid__box--pull-right" [hidden]="!cell.schedule">
        <button
          class="ctrl link link--dotted-gray-dark"
          [disabled]="isFuncDisabled || isBlockedEditCreate"
          id="{{ 'appResetCellSchedule' + cell.workday + '-' + user.u_id }}"
          type="button"
          (click)="onSaveCellData(true)"
        >
          Очистить ячейку
        </button>
      </div>
    </div>
  </ng-template>

  <ng-template #cellPrevPopContent>
    <div *ngIf="cell.schedule" style="width: 500px">
      <div>
        <span class="title"> Смена {{ cell.workday | dateFormat: 'DD MMMM YYYY г.' }} </span>
      </div>

      <div *ngIf="cell.schedule && !cell.schedule.sector">
        <div class="grid grid--gap-8 grid--va-middle mt-8">
          <div class="grid__box grid__box--size-min">
            <div class="cell-square {{ 'cell-square--' + cellSquare[cellHighlight] }}"></div>
          </div>
          <div class="grid__box grid__box--size-7">
            {{ cell.schedule && cell.schedule.cell_type && cell.schedule.cell_type.ct_name }}
            <span *ngIf="cell.schedule && cell.schedule.cell_type && cell.schedule.cell_type.ct_id === 1">
              с {{ cell.schedule && cell.schedule.int_begin | dateFormat: 'H.mm' }} до {{ cell.schedule && cell.schedule.int_end | dateFormat: 'H.mm' }}
            </span>
          </div>
        </div>
        <div class="grid mt-16" [hidden]="cell.schedule && cell.schedule.cell_type && cell.schedule.cell_type.ct_id !== 2">
          <div class="grid__box grid__box--size-5">
            <span class="title title--s">Временное место работы</span>
          </div>
          <div class="grid__box grid__box--size-7">{{ cell.schedule && cell.schedule.sector && cell.schedule.sector.sector_number_str }}</div>
        </div>
        <div class="grid mt-8" *ngIf="cell.schedule && cell.schedule.cell_type && cell.schedule.cell_type.ct_id !== 1">
          <div class="grid__box grid__box--size-5">
            <span class="title title--s">Комментарий</span>
          </div>
          <div class="grid__box grid__box--size-7">{{ cell.schedule && cell.schedule.commentary }}</div>
        </div>
      </div>

      <div *ngIf="cell.schedule && cell.schedule.sector">
        <div *ngIf="cell.schedule.sector.sector_id === filter.plotSelected.sector_id">
          <div *ngIf="cell.schedule.cell_type && cell.schedule.cell_type.ct_id === 2">
            <div class="grid grid--gap-8 grid--va-middle mt-8">
              <div class="grid__box grid__box--size-min">
                <div class="cell-square {{ 'cell-square--' + cellSquare[9] }}"></div>
              </div>
              <div class="grid__box grid__box--size-7">{{ cell.schedule && cell.schedule.cell_type && cell.schedule.cell_type.ct_name }}</div>
            </div>
          </div>
          <div *ngIf="cell.schedule.cell_type && cell.schedule.cell_type.ct_id !== 2">
            <div class="grid grid--gap-8 grid--va-middle mt-8">
              <div class="grid__box grid__box--size-min">
                <div class="cell-square {{ 'cell-square--' + cellSquare[cellHighlight] }}"></div>
              </div>
              <div class="grid__box grid__box--size-7">{{ cell.schedule && cell.schedule.cell_type && cell.schedule.cell_type.ct_name }}</div>
            </div>
            <div class="grid mt-16" [hidden]="cell.schedule && cell.schedule.cell_type && cell.schedule.cell_type.ct_id !== 2">
              <div class="grid__box grid__box--size-5">
                <span class="title title--s">Временное место работы</span>
              </div>
              <div class="grid__box grid__box--size-7">{{ cell.schedule && cell.schedule.sector && cell.schedule.sector.sector_number_str }}</div>
            </div>
          </div>
        </div>

        <div *ngIf="cell.schedule.sector.sector_id !== filter.plotSelected.sector_id">
          <div class="grid grid--gap-8 grid--va-middle mt-8">
            <div class="grid__box grid__box--size-min">
              <div class="cell-square {{ 'cell-square--' + cellSquare[cellHighlight] }}"></div>
            </div>
            <div class="grid__box grid__box--size-7">{{ cell.schedule && cell.schedule.cell_type && cell.schedule.cell_type.ct_name }}</div>
          </div>
          <div class="grid mt-16" [hidden]="cell.schedule && cell.schedule.cell_type && cell.schedule.cell_type.ct_id !== 2">
            <div class="grid__box grid__box--size-5">
              <span class="title title--s">Временное место работы</span>
            </div>
            <div class="grid__box grid__box--size-7">{{ cell.schedule && cell.schedule.sector && cell.schedule.sector.sector_number_str }}</div>
          </div>
        </div>
        <div class="grid mt-8">
          <div class="grid__box grid__box--size-5">
            <span class="title title--s">Комментарий</span>
          </div>
          <div class="grid__box grid__box--size-7">{{ cell.schedule && cell.schedule.commentary }}</div>
        </div>
      </div>
    </div>
    <div *ngIf="!cell.schedule" style="width: 180px">Нет данных для отображения</div>
  </ng-template>

  <ng-template #cellWorkTypeContent>
    <app-work-shift-button-wrapper
      [cellPopContent]="cellPopContent"
      [cellPrevPopContent]="cellPrevPopContent"
      [cell]="cell"
      [isPreviewCell]="isPreviewCell"
      [cellPopoverIsOpen]="cellPopoverIsOpen"
      [templateFilter]="templateFilter"
      [index]="index"
      [endIndex]="endIndex"
      [title]="title"
      [user]="user"
      (onOpenEditConfirmDialog)="onOpenEditConfirmDialog($event)"
      (showCell)="showCell()"
      (hideCell)="hideCell()"
    >
      <div [hidden]="cell.schedule_preview" class="cell__wrapper">
        <ng-container *ngIf="cell.schedule && !cell.relocation">
          <div
            *ngIf="!isGRS"
            class="work-shift__cell--fit
               work-shift__cell--hover
               {{ cellTypesHighlight[cellHighlight] ? 'work-shift__cell-container--' + cellTypesHighlight[cellHighlight] : '' }}"
          >
            <ng-container *ngIf="cell.schedule.sector && cell.schedule.sector.sector_id === filter.plotSelected.sector_id">
              <div class="date__work-type" *ngIf="cell.schedule && cell.schedule.cell_type && cell.schedule.cell_type.ct_id === 1">
                <div class="work-type--hover-transparent work-shift__cell--centering" data-id="1">
                  <div class="date__start-work" *ngIf="cell.schedule.int_begin">{{ cell.schedule && cell.schedule.int_begin | dateFormat: 'H.mm' }}</div>
                  <div class="date__end-work" *ngIf="cell.schedule.int_end">{{ cell.schedule && cell.schedule.int_end | dateFormat: 'H.mm' }}</div>
                  <div class="date__count-hours-work">{{ cell.schedule.int_delta | workShiftHours }}</div>
                </div>
              </div>

              <div class="date__work-type" *ngIf="cell.schedule && cell.schedule.cell_type && cell.schedule.cell_type.ct_id === 2">
                <div class="work-type--hover-transparent work-shift__cell--centering" data-id="K">
                  <div class="color-gray-dark">K</div>
                </div>
              </div>

              <div class="date__work-type" *ngIf="cell.schedule && cell.schedule.cell_type && cell.schedule.cell_type.ct_id !== 1 && cell.schedule.cell_type.ct_id !== 2">
                <div class="work-type--hover-transparent work-shift__cell--centering" data-id="2">
                  <div class="color-gray-dark">{{ cell.schedule && cell.schedule.cell_type && cell.schedule.cell_type.ct_short }}</div>
                </div>
              </div>
            </ng-container>
            <ng-container *ngIf="cell.schedule && !cell.relocation && !cell.schedule.sector">
              <div class="date__work-type" *ngIf="cell.schedule && cell.schedule.cell_type && cell.schedule.cell_type.ct_id === 1">
                <div class="work-type--hover-transparent work-shift__cell--centering" data-id="4">
                  <div class="date__start-work" *ngIf="cell.schedule.int_begin">{{ cell.schedule && cell.schedule.int_begin | dateFormat: 'H.mm' }}</div>
                  <div class="date__end-work" *ngIf="cell.schedule.int_end">{{ cell.schedule && cell.schedule.int_end | dateFormat: 'H.mm' }}</div>
                  <div class="date__count-hours-work">{{ cell.schedule.int_delta | workShiftHours }}</div>
                </div>
              </div>
            </ng-container>
          </div>

          <ng-container *ngIf="!isWorkingDay(cell) && !endsNextDay(previousCell) && isScheduleEmpty(cell)">
            <div
              class="work-shift__cell--fit work-shift__cell--hover {{
                cellTypesHighlight[cellHighlight] ? 'work-shift__cell-container--' + cellTypesHighlight[cellHighlight] : ''
              }}"
            >
              <ng-container *ngTemplateOutlet="noWorkingDays; context: { $implicit: cell, filter: filter }"></ng-container>
            </div>
          </ng-container>
        </ng-container>
        <ng-container *ngIf="cell.schedule && cell.relocation">
          <div class="date__work-type">
            <div class="work-type--hover-transparent work-shift__cell--centering" data-id="6">
              <div class="mdash"></div>
            </div>
          </div>
        </ng-container>
      </div>

      <div [hidden]="!cell.schedule_preview" data-id="preview">
        <div class="date__work-type" *ngIf="!isGRS && cell.schedule_preview && cell.schedule_preview.cell_type && cell.schedule_preview.cell_type.ct_id === 1">
          <div class="work-type--hover-transparent">
            <div class="date__start-work">{{ cell.schedule_preview && cell.schedule_preview.int_begin | dateFormat: 'H.mm' }}</div>
            <div class="date__end-work">{{ cell.schedule_preview && cell.schedule_preview.int_end | dateFormat: 'H.mm' }}</div>
            <div class="date__count-hours-work">{{ cell.schedule_preview && cell.schedule_preview.int_delta | workShiftHours }}</div>
          </div>
        </div>

        <div class="date__work-type" *ngIf="cell.schedule_preview && cell.schedule_preview.cell_type && cell.schedule_preview.cell_type.ct_id === 2">
          <div class="work-type--hover-transparent">
            <div>{{ cell.schedule_preview && cell.schedule_preview.cell_type && cell.schedule_preview.cell_type.ct_short }}</div>
            <div>{{ cell.schedule_preview && cell.schedule_preview.sector && cell.schedule_preview.sector.sector_number_str }}</div>
          </div>
        </div>
        <div
          class="date__work-type"
          *ngIf="cell.schedule_preview && cell.schedule_preview.cell_type && cell.schedule_preview.cell_type.ct_id !== 1 && cell.schedule_preview.cell_type.ct_id !== 2"
        >
          <div class="work-type--hover-transparent">
            <div class="color-gray-dark">{{ cell.schedule_preview && cell.schedule_preview.cell_type && cell.schedule_preview.cell_type.ct_short }}</div>
          </div>
        </div>
      </div>

      <div class="date_comment" *ngIf="cell.schedule_preview && cell.schedule_preview.commentary">
        <app-icon [glyph]="'comment'" [size]="'8'" [color]="'gray-dark'"></app-icon>
      </div>
    </app-work-shift-button-wrapper>

    <ng-template #noWorkingDays let-cell let-filter="filter">
      <ng-container *ngIf="cell.schedule && !cell.relocation && cell.schedule.sector && cell.schedule.sector.sector_id !== filter.plotSelected.sector_id">
        <div [hidden]="cell.schedule_preview">
          <div class="date__work-type">
            <div class="work-type--hover-transparent" data-id="3">
              <div class="color-gray-dark">{{ cell.schedule && cell.schedule.sector && cell.schedule.sector.sector_number_str }}</div>
            </div>
          </div>
          <div class="date_comment" *ngIf="cell.schedule && cell.schedule.commentary">
            <app-icon [glyph]="'comment'" [size]="'8'" [color]="'gray-dark'"></app-icon>
          </div>
        </div>
      </ng-container>

      <ng-container *ngIf="cell.schedule && !cell.relocation && !cell.schedule.sector">
        <div class="date__work-type" *ngIf="cell.schedule && cell.schedule.cell_type && cell.schedule.cell_type.ct_id !== 1 && cell.schedule.cell_type.ct_id !== 2">
          <div class="work-type--hover-transparent" data-id="5">
            <div class="color-gray-dark">{{ cell.schedule && cell.schedule.cell_type && cell.schedule.cell_type.ct_short }}</div>
          </div>
        </div>
        <div class="date_comment" *ngIf="cell.schedule && cell.schedule.commentary">
          <app-icon [glyph]="'comment'" [size]="'8'" [color]="'gray-dark'"></app-icon>
        </div>
      </ng-container>
    </ng-template>

    <div
      *ngIf="
        isGRS &&
        !cell.relocation &&
        (cell.schedule?.cell_type?.ct_id === 1 ||
          (cell.schedule &&
            cell.schedule.sector &&
            cell.schedule.sector.sector_id === filter.plotSelected.sector_id &&
            cell.schedule.cell_type &&
            cell.schedule.cell_type.ct_id === 1) ||
          cell.schedule_preview?.cell_type?.ct_id === 1 ||
          endsNextDay(previousCell))
      "
      class="date__work-type"
      [class.work-shift__cell-container--blue-light]="cell.schedule?.cell_type?.ct_id === 1 || endsNextDay(previousCell)"
      [class.work-shift__cell--disabled]="isDisabled()"
      [class.date__work-type--grs]="isGRS"
    >
      <div class="work-type--hover-transparent" data-id="4">
        <app-work-shift-button-wrapper
          [cellPopContent]="cellPopContent"
          [cellPrevPopContent]="cellPrevPopContent"
          [cell]="cell"
          [isPreviewCell]="isPreviewCell"
          [cellPopoverIsOpen]="cellPopoverIsOpen"
          [templateFilter]="templateFilter"
          [index]="index"
          [endIndex]="endIndex"
          [title]="title"
          [user]="user"
          (onOpenEditConfirmDialog)="onOpenEditConfirmDialog($event)"
          (showCell)="showCell()"
          (hideCell)="hideCell()"
        >
          <div
            class="date__start-work date__start-work--grs date__start-work--hover date__section"
            [class.date__start-work--hidden]="(!isTemplate(cell) && !isWorkingDay(cell)) || !getIntBegin(cell) || !isShown(getIntBegin(cell))"
          >
            <div class="date__start-work-value">
              {{ getIntBegin(cell) | dateFormat: 'H.mm' }}
            </div>
          </div>

          <div
            class="date__start-work date__start-work--grs date__section date__start-work--small"
            [class.date__start-work--hidden]="isWorkingDay(cell) || !endsNextDay(previousCell)"
          >
            <div class="date__start-work-value">
              <ng-container *ngTemplateOutlet="noWorkingDays; context: { $implicit: cell, filter: filter }"></ng-container>
            </div>
          </div>
        </app-work-shift-button-wrapper>

        <div class="date__end-work date__end-work--grs date__section" [class.date__end-work--mute]="cell.schedule_preview">
          <div class="date__end-work-value" [class.date__end-work--hidden]="!isShown(getIntEnd(cell)) && !isShown(getIntEnd(previousCell))">
            {{ getEndTime(getIntEnd(cell), getIntEnd(previousCell)) | dateFormat: 'H.mm' }}
          </div>
        </div>
        <div class="date__count-hours-work date__section" [class.date__count-hours-work--mute]="cell.schedule_preview">
          {{ getDelta(cell) | workShiftHours }}
        </div>
      </div>
    </div>
  </ng-template>

  <ng-container *ngIf="isGRS; else defaultTmpl">
    <div class="cell__container cell__container--no-padding">
      <ng-container *ngTemplateOutlet="cellWorkTypeContent"></ng-container>
    </div>
  </ng-container>

  <ng-template #defaultTmpl>
    <div class="cell__container" [class.cell__container--no-padding]="isTemplate(cell)">
      <ng-template *ngTemplateOutlet="cellWorkTypeContent"></ng-template>
    </div>
  </ng-template>
</div>
